import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Select from "../../UI/Select/Select";
import SecBTN from "../../UI/SecBTN";
import userService from "../../app/services/user.service";


import { useNavigate } from "react-router-dom";

const QuestionModule = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    paper: "",
    language: "",
    questionType: "",
    module: "",
    headerFile: null,
    uploadFile: null,
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileChange = (field, file) => {
    setFormData((prev) => ({
      ...prev,
      [field]: file,
    }));
  };

  const handleUpload = async () => {
    if (!formData.uploadFile) {
      alert("Please select a file to upload.");
      return;
    }

    const data = new FormData();
    data.append("paper", formData.paper);
    data.append("language", formData.language);
    data.append("question_type", formData.questionType);
    data.append("module", formData.module);
    data.append("header_file", formData.headerFile);
    data.append("data_file", formData.uploadFile);

    userService
    .QuestionModuleUpload(data)
    .then((res) => {
      console.log("API success", res.result);
      alert("About section uploaded successfully!");
      navigate('/questionmodule',{ state: { responseData: res.result,language:formData.language } })
      
    })
    .catch((err) => {
      console.error("API error", err);
      alert("Failed to upload About section.");
    });
  };

  const downloadFile = () => {
    fetch(window.location.origin + "/files/temp.xlsx")
      .then((response) => response.blob())
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.href = fileURL;
        link.download = "sample.xlsx";
        link.click();
      })
      .catch((error) => console.error("Download error:", error));
  };

  return (
    <Row>
      <Col lg={6} md={6} sm={12} className="mb-3">

      <Form.Group controlId="formModule" className="mb-3">
          <Form.Label>Select Module:</Form.Label>
          <Select value={formData.module} onChange={(e) => handleChange("module", e.target.value)}>
            <option value="">Select</option>
            <option value="question">Question</option>
            <option value="solution">Solution</option>
          </Select>
        </Form.Group>

        <Form.Group controlId="formPaper" className="mb-3">
          <Form.Label>Select Paper:</Form.Label>
          <Select value={formData.paper} onChange={(e) => handleChange("paper", e.target.value)}>
            <option value="">Select</option>
            <option value="jee">JEE</option>
            <option value="neet">NEET</option>
          </Select>
        </Form.Group>

        <Form.Group controlId="formLanguage" className="mb-3">
          <Form.Label>Select Language:</Form.Label>
          <Select value={formData.language} onChange={(e) => handleChange("language", e.target.value)}>
            <option value="">Select</option>
            <option value="english">English</option>
            <option value="hindi">Hindi</option>
            
          </Select>
        </Form.Group>

        <Form.Group controlId="formQuestionType" className="mb-3">
          <Form.Label>Select Subject:</Form.Label>
          <Select value={formData.questionType} onChange={(e) => handleChange("questionType", e.target.value)}>
            <option value="">Select</option>
            <option value="1">Physics</option>
            <option value="2">Chemistry</option>
            <option value="3">Maths</option>
            <option value="4">Biology</option>
          </Select>
        </Form.Group>

        

        <Form.Group controlId="formHeaderFile" className="mb-3">
          <Form.Label>Upload Header File:</Form.Label>
          <Form.Control type="file" onChange={(e) => handleFileChange("headerFile", e.target.files[0])} />
        </Form.Group>

        <Form.Group controlId="formUploadFile" className="mb-3">
          <Form.Label>Upload File:</Form.Label>
          <Form.Control type="file" onChange={(e) => handleFileChange("uploadFile", e.target.files[0])} />
        </Form.Group>

        <SecBTN className="sec-btn1" onClick={handleUpload}>
          Upload
        </SecBTN>
      </Col>

      <Col lg={6} md={6} sm={12}>
        <SecBTN className="sec-btn1" onClick={downloadFile}>
          <i className="fa fa-download"></i> Sample File
        </SecBTN>
      </Col>
    </Row>
  );
};

export default QuestionModule;
